import React from 'react';

import {
  IconButton,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
  makeStyles,
  Grid,
} from '@material-ui/core';

import DeleteIcon from '@material-ui/icons/Delete';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import CancelIcon from '@material-ui/icons/Cancel';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import RestoreIcon from '@material-ui/icons/Restore';

const useStyles = makeStyles(theme => ({
  row: {
    '&:nth-child(odd)': {
      backgroundColor: ({ variant }) =>
        variant === 'primary' ? 'none' : '#e3e3e3',
    },
    '&:nth-child(even)': {
      backgroundColor: ({ variant }) =>
        variant === 'primary' ? 'none' : '#a9a9a9',
    },
  },
  label: {
    color: '#464b51',
  },
}));

const WellnubTableRow = ({
  row: { data, id },
  actions,
  disabled,
  variant = 'primary',
  actionPosition,
}) => {
  const rowKeys = Object.keys(data);

  const classes = useStyles({ variant });

  return (
    <TableRow className={classes.row}>
      {actions && actionPosition === 'start' && (
        <TableCell align="center">
          <Grid container>
            {actions.map(({ title, type, handler }) => (
              <Grid item>
                <Tooltip key={title} title={title}>
                  <IconButton
                    size="small"
                    onClick={() => handler(id)}
                    disabled={disabled}
                  >
                    {type === 'DELETE' && <DeleteIcon fontSize="small" />}
                    {type === 'CANCEL' && <CancelIcon fontSize="small" />}
                    {type === 'CHECK_IN' && (
                      <AssignmentTurnedInIcon fontSize="small" />
                    )}
                    {type === 'UNDO' && <RestoreIcon fontSize="small" />}
                  </IconButton>
                </Tooltip>
              </Grid>
            ))}
          </Grid>
        </TableCell>
      )}
      {rowKeys.map(key => (
        <TableCell align="center" key={`${key}-${data[key]}`}>
          <Typography className={classes.label} variant="body2">
            {data[key]}
          </Typography>
        </TableCell>
      ))}
      {actions && actionPosition === 'end' && (
        <TableCell align="center">
          <Grid container spacing={1} justifyContent="center">
            {actions.map(({ title, type, handler }) => (
              <Grid item key={title}>
                <Tooltip title={title}>
                  <IconButton
                    size="small"
                    onClick={() => handler(id)}
                    disabled={disabled}
                  >
                    {type === 'DELETE' && <DeleteIcon fontSize="small" />}
                    {type === 'FILE' && <AttachFileIcon fontSize="small" />}
                    {type === 'CANCEL' && <CancelIcon fontSize="small" />}
                    {type === 'CHECK_IN' && (
                      <AssignmentTurnedInIcon fontSize="small" />
                    )}
                    {type === 'UNDO' && <RestoreIcon fontSize="small" />}
                  </IconButton>
                </Tooltip>
              </Grid>
            ))}
          </Grid>
        </TableCell>
      )}
    </TableRow>
  );
};

export default WellnubTableRow;
